module.exports = __webpack_public_path__ + "img/202510_01.760eb30e.png";